export const GET_ACTIVATION_REQUIRED_REQUEST="GET_ACTIVATION_REQUIRED_REQUEST"
export const GET_ACTIVATION_REQUIRED_SUCCESS="GET_ACTIVATION_REQUIRED_SUCCESS"
export const GET_ACTIVATION_REQUIRED_FAILURE="GET_ACTIVATION_REQUIRED_FAILURE"